module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "show-more"
  }, [_c('spinner', {
    staticClass: "spinner-component",
    attrs: {
      "show": _vm.showSpinner
    }
  }), _vm._v(" "), (_vm.hasNextPage && !_vm.showSpinner) ? _c('p', [_vm._v(_vm._s(_vm.$t('showMore'))), _c('span', {
    staticClass: "glyphicon glyphicon-menu-right",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-87ef3e74!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShowMore.vue
// module id = 1363
// module chunks = 1